import React from "react";
import classNames from "classnames";
import css from "./style.scss";

const CheckboxItem = ({ 
  label, 
  onChange, 
  checked = false, 
  disabled = false, 
  labelClassName, 
  boxClassName, 
  checkmarkClassName,
  containerClassName,
  name,
  value
}) => {

  const handleChange = (e) => {
    if (onChange) {
      const eventObj = {
        target: {
          name: name || label,
          value: value !== undefined ? value : label,
          checked: e.target.checked
        }
      };
      onChange(eventObj);
    }
  };

  return (
    <div className={classNames(css.checkboxWrapper, containerClassName)}>
      <label className={classNames(css.checkboxContainer, boxClassName, { [css.disabled]: disabled })}>
        <input 
          type="checkbox" 
          checked={checked} 
          onChange={handleChange} 
          disabled={disabled}
          name={name}
        />
        <span className={classNames(css.checkmark, checkmarkClassName)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10" fill="none">
             <path d="M13.7065 0.292923C14.097 0.683487 14.097 1.31776 13.7065 1.70833L5.7077 9.70708C5.31714 10.0976 4.68286 10.0976 4.2923 9.70708L0.292923 5.7077C-0.097641 5.31714 -0.097641 4.68286 0.292923 4.2923C0.683487 3.90173 1.31776 3.90173 1.70833 4.2923L5.00156 7.58241L12.2942 0.292923C12.6847 -0.097641 13.319 -0.097641 13.7096 0.292923H13.7065Z" fill="white"/>
          </svg>
        </span>
      </label>
      <span className={classNames(css.checkboxtxt, labelClassName)}>{label}</span>
    </div>
  );
};

export default CheckboxItem;